import * as React from 'react';
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { traducirButton } from '../../blocks/traductor';

interface IProps {
    label?: string
}

const SubmitButton = ({label = traducirButton(15)}: IProps) => {
    return (<>
        <Box display="flex" justifyContent="flex-end" mt={2}>
            <Box>
                <Button type="submit" variant="contained" color="primary">
                    {label}
                </Button>
            </Box>
        </Box>
    </>)
};

export default SubmitButton;
